import React from 'react';
import { Link } from 'react-router-dom';
import { ConnectorIconBetaLabel } from '../../products/ElementListElement';
import { ConnectorList, ConnectorTypeEnum } from './ConnectorTypes';
import {
	OtherConnectorsCard,
	OtherConnectorsContent,
	OtherConnectorsContentLinkWrapper,
	OtherConnectorsImageWrapper,
} from './Styles';
type OtherConnectorsElementProps = {
	exceptForType: ConnectorTypeEnum;
};

const OtherConnectorsElement: React.FC<OtherConnectorsElementProps> = (props) => {
	return (
		<OtherConnectorsCard>
			<h1>Other Connectors</h1>
			<OtherConnectorsContent>
				{ConnectorList.filter((x) => x.type !== props.exceptForType).map((item) => (
					<Link to={item.link} key={item.name}>
						<OtherConnectorsContentLinkWrapper>
							<OtherConnectorsImageWrapper>
								<img src={item.icon(40)} alt={item.name} width={40} />
								{item.isBeta && (
									<ConnectorIconBetaLabel style={{ right: 25 }}>BETA</ConnectorIconBetaLabel>
								)}
							</OtherConnectorsImageWrapper>
							<h3>{item.name}</h3>
						</OtherConnectorsContentLinkWrapper>
					</Link>
				))}
			</OtherConnectorsContent>
		</OtherConnectorsCard>
	);
};
export default OtherConnectorsElement;
